// TODO: Move/merge with product util in peregrine?
export var isProductConfigurable = function isProductConfigurable(product) {
  return product.__typename === 'ConfigurableProduct';
};